const excludeEmptyParams = (params) => {
    const result = {};
    Object.keys(params).forEach((key) => {
        if (params[key]) {
            result[key] = params[key];
        }
    });
    return result;
};

const queryParams = (url, params) => {
    if (!Object.keys(params).length) {
        return url;
    }

    params = excludeEmptyParams(params);

    const searchParams = new URLSearchParams();
    Object.keys(params).forEach((key) => searchParams.append(key, params[key]));

    return (
        url + (url.indexOf('?') === -1 ? '?' : '&') + searchParams.toString()
    );
};

export default queryParams;
